import React, { useRef } from 'react';
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@roger/ui-components';
import PermissionsTable, {
  type PermissionsTableHandle,
} from '../../components/rbac/PermissionsTable';
import CreatePermissionButton from '../../components/rbac/CreatePermissionButton';

const PermissionManagementTab: React.FC = () => {
  const tableRef = useRef<PermissionsTableHandle>(null);

  return (
    <Card>
      <CardHeader className='flex flex-row items-start justify-between'>
        <div>
          <CardTitle>Permissions</CardTitle>
          <CardDescription>
            All permissions available in the system that can be assigned to
            roles.
          </CardDescription>
        </div>
        <CreatePermissionButton onCreated={() => tableRef.current?.refresh()} />
      </CardHeader>
      <PermissionsTable ref={tableRef} />
    </Card>
  );
};

export default PermissionManagementTab;
